import { useTranslation } from 'react-i18next';

import { useNotification } from 'providers/NotificationProvider';

export const useUpdateMyProfileDetailsAlerts = () => {
  const { t } = useTranslation('myProfile');
  const { showNotification } = useNotification();

  const wrongUserAbout = () => {
    showNotification({
      title: t('account-settings.user-about-restriction.alert-title'),
      description: t('account-settings.user-about-restriction.alert-description'),
      type: 'error',
    });
  };

  const wrongUserName = () => {
    showNotification({
      title: t('account-settings.user-name-restriction.alert-title'),
      description: t('account-settings.user-name-restriction.alert-description'),
      type: 'error',
    });
  };

  const unknownError = () => {
    showNotification({
      title: t('account-settings.cannot-update-user'),
      type: 'error',
    });
  };

  const userDetailsUpdated = () => {
    showNotification({
      title: t('account-settings.user-updated'),
      type: 'success',
    });
  };

  return { userDetailsUpdated, wrongUserAbout, wrongUserName, unknownError };
};
